export const GET_REGISTER_WITHOUT_SESSION = 'GET_REGISTER_WITHOUT_SESSION';
export const SET_REGISTER_WITHOUT_SESSION = 'SET_REGISTER_WITHOUT_SESSION';

export const GET_REGISTER_WITH_SESSION = 'GET_REGISTER_WITH_SESSION';
export const SET_REGISTER_WITH_SESSION = 'SET_REGISTER_WITH_SESSION';

export const getRegisterHtmlWithoutSession = (payload) => {
    return {
        type: GET_REGISTER_WITHOUT_SESSION,
        payload
    }
   
}

export const setRegisterHtmlWithoutSession = (payload) => {
    return {
        type: SET_REGISTER_WITHOUT_SESSION,
        payload
    }
}

export const getRegisterHtmlWithSession = (payload) => {
    return {
        type: GET_REGISTER_WITH_SESSION,
        payload
    }
}
export const setRegisterHtmlWithSession = (payload) => {
    return {
        type: SET_REGISTER_WITH_SESSION,
        payload
    }
}
